/* eslint-disable */
export default {
  header: 'Contacter l’assistance',
  toggleTitle: '1. Activez le mode de suivi des erreurs.',
  toggleDescription:
    'Cela nous aidera à localiser les problèmes que vous rencontrez, mais peut affecter légèrement les performances de votre application.',
  downloadTitle:
    '2. Téléchargez le journal des erreurs lorsque vous avez répliqué le problème.',
  downloadButton: 'Télécharger',
  downloadDisabledTitle:
    'Activez le mode de suivi des erreurs avant de pouvoir télécharger le journal des erreurs.',
  sendTitle: '3. Envoyez le journal à l’équipe d’assistance.',
  createSupportTicket: 'Créez un ticket d’assistance',
  sendDescription:
    ' pour entrer en contact avec notre équipe d’assistance. Envoyez ensuite le journal à l’équipe d’assistance pour dépannage.',
  privacyNotice:
    'En téléchargeant le journal et en nous l’envoyant, vous acceptez d’autoriser RingCentral à accéder à certaines informations relatives aux journaux à des fins de dépannage et de gestion des erreurs. Pour plus d’informations sur la façon dont RingCentral traite les données personnelles, veuillez consulter nos ',
  privacyNoticeLink: 'Conditions d’utilisation du service',
  and: ' et ',
  privacyNoticeEnd: 'notre Déclaration de confidentialité.',
  needLeavePage:
    'Vous pouvez quitter cette page pendant que le suivi des erreurs est en cours d’exécution. Une fois que vous avez répliqué le problème, revenez sur cette page et téléchargez les fichiers journaux.',
  downloading: 'Téléchargement en cours',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
